
import { defineComponent, PropType, ref, watch } from 'vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { UsedGroupService } from '@/views/dashboard/_components/used-group/used-group.service'
import { Group } from '@/views/dashboard/_type/group'
import { PolicyType } from '@/views/dashboard/_enum/policy-type'

export default defineComponent({
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    policyId: {
      type: String,
      default: undefined
    },
    name: {
      type: String,
      default: ''
    },
    strategyType: {
      type: Number as PropType<PolicyType>,
      default: 1
    },
  },

  setup(props, context) {
    const injector = useReflectiveInjector([UsedGroupService])
    const service = injector.get(UsedGroupService)

    const isLoading = ref(false)
    const groupData = ref({} as Group)

    function updateData() {
      isLoading.value = true
      service.getTerminalGroup({
        strategy_id: props.policyId,
        strategy_type: props.strategyType
      }).then(response => {
        groupData.value = response.group
        console.log('groupData.value', groupData.value)
      }).finally(() => {
        isLoading.value = false
      })
    }

    function handleClose() {
      context.emit('update:modelValue', false)
    }

    watch(() => props.modelValue, (value) => {
      if (value) {
        updateData()
      }
    }, { immediate: true })

    return {
      isLoading,
      groupData,
      handleClose,
    }
  }
})
